<template>
    <v-speed-dial v-model="fab" bottom right fixed style="z-index: 6;" :class="[{'fixed-bottom': fixedBottom && isMobile}]">
        <template v-slot:activator>
            <v-btn v-model="fab" color="primary" class="black--text" dark fab depressed small>
                <v-icon>
                    {{ fab ? 'mdi-close' : icon }}
                </v-icon>
            </v-btn>
        </template>
        <v-btn fab dark depressed small color="black" v-for="(item, i) in items" :key="i" @click="$emit(`click:${item.value}`)">
            <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
    </v-speed-dial>
</template>

<script>
export default {
    name: "FabMenu",
    props: {
        items: {
            type: Array,
            default: () => []
        },
        icon: {
            type: String,
            default: 'mdi-menu'
        },
        fixedBottom: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            fab: false
        }
    },
}
</script>

<style scoped>

.fixed-bottom {
    bottom: 86px;
}

</style>